<!--
 * @Description: 
 * @Date: 2021-12-14 11:43:35
-->
<template>
  <div class="confirm">
    <p style="color:#6E6E6E;font-size:.37rem">
      为了保障您的账号安全注销前需要您本人进行用户 身份验证
    </p>
    <div style="text-align:center;margin-top:1.41rem">
      <h1>当前绑定手机号</h1>
      <h1 style="margin-top:.32rem">{{ phone | phoneFil }}</h1>
    </div>
    <div class="confirm__input">
      <div>
        <input type="text" v-model="verifyCode" />
        <span :style="{ color: sendTextColor }" @click="onSendSms">
          {{ sendText }}
        </span>
      </div>
    </div>
    <van-button
      type="primary"
      color="#5494FC"
      block
      style="margin-top:1.51rem"
      :disabled="!verifyCode"
      @click="onConfirm"
      :loading="verifyCodeLoading"
    >
      确认注销
    </van-button>
    <van-dialog
      v-model="showVerifyImgCode"
      title="图形验证码"
      show-cancel-button
      :beforeClose="beforeCloseVerifyImgCode"
    >
      <div
        class="confirm__input"
        style="width:70%;margin:0 auto;margin-top:.5rem"
      >
        <div>
          <input type="text" v-model="verifyImgCode" />
          <img
            style="width:2.3rem"
            :src="verifyImgCodeSrc"
            @click="onChangeVerifyImgCode"
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { verifyImgCode, sendMessageCode, accountLogout } from '@/api/ajax';
export default {
  name: 'PersonalLogOffConfirm',
  data() {
    return {
      showVerifyImgCode: false,
      verifyImgCodeSrc: this.$config.javaPath + verifyImgCode,
      verifyImgCode: '',
      verifyCode: '',
      sendText: '获取验证码',
      verifyCodeLoading: false
    };
  },
  computed: {
    sendTextColor() {
      return ['获取验证码', '重新发送'].includes(this.sendText)
        ? '#2F7DFB'
        : '#6E6E6E';
    },
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    }),
    phone() {
      return this.wxUserInfo.phone;
    },
    canSend() {
      return ['获取验证码', '重新发送'].includes(this.sendText);
    }
  },
  filters: {
    phoneFil(e) {
      return e.substr(0, 3) + '****' + e.substr(7);
    }
  },
  methods: {
    onChangeVerifyImgCode() {
      this.verifyImgCodeSrc =
        this.$config.javaPath + verifyImgCode + '?t=' + Date.now();
    },
    async beforeCloseVerifyImgCode(action, done) {
      if (action === 'cancel') {
        this.verifyImgCode = '';
        done();
      } else {
        try {
          if (this.canSend) {
            let s = 60;
            let inter = null;
            this.sendText = s + 's';
            inter = setInterval(async () => {
              if (s === 1) {
                clearInterval(inter);
                s = 60;
                this.sendText = '重新发送';
                return;
              }
              s--;
              this.sendText = s + 's';
            }, 1000);
            try {
              await sendMessageCode({
                imgVerifyCode: this.verifyImgCode,
                phone: this.phone,
                source: 3
              });
              done();
            } catch (e) {
              inter && clearInterval(inter);
              s = 60;
              this.sendText = '重新发送';
              done(false);
            }
          }
        } catch (e) {
          this.onChangeVerifyImgCode();
          done(false);
        }
      }
    },
    onSendSms() {
      this.showVerifyImgCode = this.canSend;
    },
    async onConfirm() {
      if (this.verifyCode) {
        this.verifyCodeLoading = true;
        try {
          await accountLogout({ verifyCode: this.verifyCode });
          sessionStorage.clear();
          localStorage.clear();
          this.$router.push({ name: 'home' });
        } catch (e) {
          this.verifyCodeLoading = false;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.confirm {
  padding: 0 0.8rem;
  padding-top: 0.92rem;
  * {
    font-size: 0.37rem;
  }
  &__input {
    * {
      font-size: 0.4rem;
    }
    margin-top: 0.87rem;
    div {
      display: flex;
      align-items: center;
      width: 100%;
      height: 1.2rem;
      border: 0.03rem solid #e2e2e2;
      border-radius: 0.13rem;
      position: relative;
      z-index: 1;
      input {
        border: none;
        width: 65%;
        height: 1rem;
        padding-left: 0.44rem;
      }
      span {
        width: 2.07rem;
        text-align: center;
      }
    }
  }
}
</style>
